import React from "react";
import { GatsbyBrowser } from "gatsby";
import { PluginProviders, ProviderType } from "./providers/PluginProviders";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element, props }) => {
  return <PluginProviders providers={props.pageContext.providers as ProviderType[]}>{element}</PluginProviders>;
};
